export const MAP_LINK_ERROR = 'Please paste a Google Maps link (maps.app.goo.gl, google.com/maps, maps.google.com or goo.gl/maps).';

// Mirrors backend routes/challenges.py::normalize_map_link.
export const isValidMapLink = (raw) => {
  const s = (raw || '').trim();
  if (!s) return true;
  if (s.length > 500 || /\s/.test(s)) return false;
  let u;
  try { u = new URL(s); } catch { return false; }
  if (u.protocol !== 'https:' || u.username || u.password || u.port) return false;
  const host = u.hostname.toLowerCase();
  const path = u.pathname;
  if (host === 'maps.app.goo.gl') return path.length > 1;
  if (host === 'maps.google.com') return true;
  if (host === 'www.google.com') return path === '/maps' || path.startsWith('/maps/');
  if (host === 'goo.gl') return path === '/maps' || path.startsWith('/maps/');
  return false;
};

const ONLINE_RE = /\b(online|virtual|zoom|teams|google meet|remote|anywhere|flexible)\b/i;

// Returns { open, directions } URLs, or null when the buttons should be hidden.
export const buildMapUrls = (locationText, mapLink) => {
  const loc = (locationText || '').trim();
  const link = (mapLink || '').trim();
  if (loc && ONLINE_RE.test(loc)) return null;
  if (!link && !loc) return null;
  const q = encodeURIComponent(loc);
  return {
    open: link || `https://www.google.com/maps/search/?api=1&query=${q}`,
    directions: link || `https://www.google.com/maps/dir/?api=1&destination=${q}`,
  };
};

export const MEETING_LINK_ERROR = 'Meeting link must be a secure https:// link with no spaces (max 500 characters).';

// Mirrors backend routes/challenges.py::normalize_meeting_link.
export const isValidMeetingLink = (raw) => {
  const s = (raw || '').trim();
  if (!s) return true;
  if (s.length > 500 || /\s/.test(s)) return false;
  try { const u = new URL(s); return u.protocol === 'https:' && !!u.hostname; } catch { return false; }
};
